import ActualSpeedWidgetContainer from "./ActualSpeedWidgetContainer";
export type { ActualSpeedApiResponse } from "./ActualSpeed";

export default ActualSpeedWidgetContainer;
